import { render } from "./UserSvg.vue?vue&type=template&id=06e32bc5"
import script from "./UserSvg.vue?vue&type=script&lang=js"
export * from "./UserSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__